// src/Projects.js
import React, { useState } from "react";
import { Card, Typography, Row, Col, Button, Modal, Image, List } from "antd";
import { CloseOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { ALL_SERVICES_DATA } from "../constants";

const { Title, Paragraph } = Typography;

const ServicesPage = (props) => {
  const { isMobile } = props;
  return (
    <div
      style={{
        paddingTop: isMobile ? 30 : 60,
        paddingBottom: "30px",
        paddingLeft: isMobile ? 0 : 50,
        paddingRight: isMobile ? 0 : 50,
      }}
    >
      <Title level={3}>Services</Title>
      <div style={{ paddingBottom: "30px", fontSize: "16px" }}>
        Welcome to Eljousour Studio's services section, where we bring your
        ideas to life with a touch of creativity and innovation. Our team is
        dedicated to providing a range of services tailored to meet your unique
        needs. Whether you're looking for stunning designs, cutting-edge
        development, or strategic consulting, we've got you covered.
      </div>
      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 4,
        }}
        dataSource={ALL_SERVICES_DATA}
        renderItem={(entry, index) => (
          <List.Item>
            <ServiceCard
              title={entry.title}
              subtitle={entry.subtitle}
              description={entry.description}
              image={entry.image}
              url={entry.url}
            />
          </List.Item>
        )}
      />
    </div>
  );
};
const ServiceCard = ({ title, subtitle, description, image, url }) => {
  const [visible, setVisible] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleImageLoaded = () => {
    setLoading(false);
  };

  const openUrl = () => {
    window.open(url, "_blank");
  };

  return (
    <Card
      style={{
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
        width: "100%",
      }}
      cover={
        <img
          alt={title}
          src={image}
          style={{ objectFit: "cover", height: "180px" }}
        />
      }
    >
      <div style={{ color: "grey" }}>{subtitle}</div>
      <Title level={4}>{title}</Title>
      <Paragraph ellipsis={{ rows: 2, expandable: false }}>
        {description}
      </Paragraph>
      <Row gutter={8}>
        <Col span={12}>
          <Button
            type="ghost"
            style={{ borderRadius: "8px", width: "100%" }}
            onClick={showModal}
          >
            Details
          </Button>
        </Col>
        <Col span={12}>
          <Button
            type="primary"
            style={{ borderRadius: "8px", width: "100%" }}
            onClick={openUrl}
          >
            Order
          </Button>
        </Col>
      </Row>

      <Modal
        title={null}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        centered
        bodyStyle={{ padding: 0 }}
      >
        <img
          alt={title}
          src={image}
          style={{ width: "100%", objectFit: "cover" }}
          onLoad={handleImageLoaded}
          loading={loading}
        />
        <div style={{ padding: "20px" }}>
          <Title level={3}>{title}</Title>
          <Title level={5}>{subtitle}</Title>
          <Paragraph>{description}</Paragraph>
          <Button
            size="large"
            icon={<CloseOutlined />}
            type="ghost"
            style={{ borderRadius: "8px", width: "100%" }}
            onClick={handleCancel}
          >
            Close
          </Button>
          <Button
            size="large"
            icon={<ShoppingCartOutlined />}
            type="primary"
            style={{ borderRadius: "8px", width: "100%" }}
            onClick={openUrl}
          >
            Order
          </Button>
        </div>
      </Modal>
    </Card>
  );
};
export default ServicesPage;
